import { useExtendedSWR } from '../base';

export function useDaily() {
  return useExtendedSWR('/daily');
}
